import type { ApiResponse } from '../../../../config/api-types'
import type { ResetPasswordRequest } from '../../domain/models/reset-password'
import type { IResetPassword } from '../../domain/use-cases/i-reset-password'

export class ResetPasswordController {
  constructor(private readonly repository: IResetPassword) {}

  async reset(params: ResetPasswordRequest): Promise<ApiResponse> {
    try {
      const result = await this.repository.reset(params)
      return result
    } catch (error) {
      throw error
    }
  }
}
